import type { Editor } from "@tiptap/react";

import {
  ALIGNABLE_ELEMENTS,
  ALIGNMENT_TYPES,
  type AlignmentType,
} from "../constants";

export interface AlignmentOption {
  iconType: string;
  isActiveFn: () => boolean;
  label: string;
  name: string;
  onClick: () => void;
}

export const isAlignmentActive = (
  editor: Editor,
  alignment: AlignmentType,
): boolean => {
  const hasActiveAlignment = ALIGNABLE_ELEMENTS.some(element =>
    editor.isActive(element, { textAlign: alignment }),
  );

  if (alignment === ALIGNMENT_TYPES.LEFT) {
    return (
      hasActiveAlignment ||
      !ALIGNABLE_ELEMENTS.some(element =>
        [ALIGNMENT_TYPES.CENTER, ALIGNMENT_TYPES.RIGHT].some(align =>
          editor.isActive(element, { textAlign: align }),
        ),
      )
    );
  }

  return hasActiveAlignment;
};
